import { Pension, PensionDeclarationSchema } from '~/types';

export const provider: string = 'ReAssure';

export const initialPension: Pension = {
    policyNumber: '',
    provider,
    value: '',
    moneyWithdrawn: '',
    employerContribution: '',
};

export const pensionProviderListItems = [
    {
        label: 'Pension provider',
        value: provider,
    },
];

export const initialDeclaration: PensionDeclarationSchema = {
    pensionDeclaration: {
        declaration: false,
    },
};
